import { IState } from '../../store';

export const selectBuilderFacts = (state: IState) => {
  return state.offerData.company?.advantages || null;
};
